/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Page_RetryInputs */

const vi_error_page_retry = /** @type {(inputs: Error_Page_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử lại`)
};

/**

* @param {Error_Page_RetryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_page_retry = /** @type {((inputs?: Error_Page_RetryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Page_RetryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_page_retry(inputs)
});